import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref } from 'vue';
import i18n from "@/locale/i18n";


export default /*#__PURE__*/_defineComponent({
  __name: 'XTimeDropDown',
  setup(__props) {

const t = i18n.global.t;
// const timeHalfHourTypes = ref(TimeConfig.iTimeHalfHourType);

const timeHalfHourTypes = ref(
    [
        { "label": "00:00", "value": "00:00" }, 
        { "label": "00:30", "value": "00:30" }, 
        { "label": "01:00", "value": "01:00" }, 
        { "label": "01:30", "value": "01:30" }, 
        { "label": "02:00", "value": "02:00" }, 
        { "label": "02:30", "value": "02:30" }, 
        { "label": "03:00", "value": "03:00" }, 
        { "label": "03:30", "value": "03:30" }, 
        { "label": "04:00", "value": "04:00" }, 
        { "label": "04:30", "value": "04:30" }, 
        { "label": "05:00", "value": "05:00" }, 
        { "label": "05:30", "value": "05:30" }, 
        { "label": "06:00", "value": "06:00" }, 
        { "label": "06:30", "value": "06:30" }, 
        { "label": "07:00", "value": "07:00" }, 
        { "label": "07:30", "value": "07:30" }, 
        { "label": "08:00", "value": "08:00" }, 
        { "label": "08:30", "value": "08:30" }, 
        { "label": "09:00", "value": "09:00" }, 
        { "label": "09:30", "value": "09:30" }, 
        { "label": "10:00", "value": "10:00" }, 
        { "label": "10:30", "value": "10:30" }, 
        { "label": "11:00", "value": "11:00" }, 
        { "label": "11:30", "value": "11:30" },
        { "label": "12:00", "value": "12:00" }, 
        { "label": "12:30", "value": "12:30" }, 
        { "label": "13:00", "value": "13:00" }, 
        { "label": "13:30", "value": "13:30" }, 
        { "label": "14:00", "value": "14:00" }, 
        { "label": "14:30", "value": "14:30" }, 
        { "label": "15:00", "value": "15:00" }, 
        { "label": "15:30", "value": "15:30" }, 
        { "label": "16:00", "value": "16:00" }, 
        { "label": "16:30", "value": "16:30" }, 
        { "label": "17:00", "value": "17:00" }, 
        { "label": "17:30", "value": "17:30" }, 
        { "label": "18:00", "value": "18:00" }, 
        { "label": "18:30", "value": "18:30" }, 
        { "label": "19:00", "value": "19:00" }, 
        { "label": "19:30", "value": "19:30" }, 
        { "label": "20:00", "value": "20:00" }, 
        { "label": "20:30", "value": "20:30" }, 
        { "label": "21:00", "value": "21:00" }, 
        { "label": "21:30", "value": "21:30" }, 
        { "label": "22:00", "value": "22:00" }, 
        { "label": "22:30", "value": "22:30" }, 
        { "label": "23:00", "value": "23:00" }, 
        { "label": "23:30", "value": "23:30" },
        { "label": "24:00", "value": "24:00" },
        { "label": "24:30", "value": "24:30" },
        { "label": "25:00", "value": "25:00" },
        { "label": "25:30", "value": "25:30" },
        { "label": "26:00", "value": "26:00" },
        { "label": "26:30", "value": "26:30" },
        { "label": "27:00", "value": "27:00" },
        { "label": "27:30", "value": "27:30" },
        { "label": "28:00", "value": "28:00" },
        { "label": "28:30", "value": "28:30" },
        { "label": "29:00", "value": "29:00" },
        { "label": "29:30", "value": "29:30" },
        { "label": "30:00", "value": "30:00" }]
);


return (_ctx: any,_cache: any) => {
  const _component_XDropdown = _resolveComponent("XDropdown")!

  return (_openBlock(), _createBlock(_component_XDropdown, {
    options: timeHalfHourTypes.value,
    optionLabel: "label",
    optionValue: "value",
    dropdownIcon: "\"pi pi-clock\"",
    placeholder: '',
    class: "x-time-drop-down"
  }, null, 8, ["options"]))
}
}

})